import { useTenant } from '@/providers/TenantProvider';

/**
 * Recursos que a Xtreed liga ou desliga por cliente.
 *
 * As flags viajam no `/tenant/config`, que já é carregado antes do primeiro
 * render — então não há chamada extra nem piscada de menu aparecendo e sumindo.
 */
export type Recurso =
  'community' | 'certificates' | 'gamification' | 'assistant';

export function useRecursoAtivo(recurso: Recurso): boolean {
  const tenant = useTenant();

  // Sem cliente resolvido (raiz da plataforma) nenhum recurso de área de
  // membros faz sentido.
  if (!tenant) return false;

  // O backend já cruza "está no plano" com "o cliente ligou" e entrega o
  // resultado; repetir a regra aqui só criaria uma segunda versão dela para
  // divergir depois.
  return tenant.featureFlags?.[recurso] === true;
}
